module.exports = "/packs/media/images/icons/harborreport_1-4889bd921c306e12a691396af166cfc2.png";